import { SectionHead } from "./SectionHead";
import { IMAGES } from "@/lib/product";
import { Lightbox } from "./Lightbox";

const SPECS = [
  ["Modèle", "Midea PortaSplit 12 000 BTU — MMCS-12HRN8-QRD0"],
  ["Type", "Climatiseur split mobile réversible (pompe à chaleur)"],
  ["Fonctions", "4-en-1 : froid, chaud, déshumidification, ventilation"],
  ["Puissance", "12 000 BTU/h (3,5 kW)"],
  ["Surface conseillée", "Jusqu'à ~40 m² (selon isolation et exposition)"],
  ["Classe énergétique froid", "A++ (SEER 6,1)"],
  ["Classe énergétique chaud", "A+ (SCOP 4,0)"],
  ["Niveau sonore intérieur", "39 dB(A) en mode silencieux"],
  ["Acoustique", "Compresseur dans l'unité extérieure, isolation triple couche"],
  ["Réfrigérant", "R32 (0,62 kg)"],
  ["Connectivité", "Wi-Fi, application Midea SmartHome"],
  ["Commande vocale", "Amazon Alexa, Google Home, Siri"],
  ["Unité intérieure", "646 × 518 × 340 mm — 32,5 kg, sur roulettes"],
  ["Unité extérieure", "438 × 500 × 260 mm — 9,9 kg"],
  ["Installation", "~10 min, sans perçage ni technicien"],
  ["Accessoires", "Kit fenêtre inclus · support toit en option"],
];

export const Specs = () => (
  <section id="fiche-technique" data-testid="spec-sheet-section" className="section bg-ice-soft">
    <div className="container-x grid lg:grid-cols-[0.8fr_1.2fr] gap-12 items-start">
      <div className="lg:sticky lg:top-28 flex flex-col gap-8">
        <SectionHead eyebrow="Fiche technique" title="Les chiffres, sans détour." />
        <div className="grid grid-cols-2 gap-4">
          <Lightbox src={IMAGES.packStacked} alt="Midea PortaSplit : unité extérieure posée sur l'unité intérieure" label="Unités empilées" testid="spec-packshot" />
          <Lightbox src={IMAGES.energyLabel} alt="Étiquette énergie MMCS-12HRN8-QRD0 : A++ SEER 6,1 / A+ SCOP 4,0" label="Étiquette énergie" testid="spec-energy-label" />
        </div>
        <Lightbox src={IMAGES.exploded} alt="Vue éclatée du Midea PortaSplit" label="Vue éclatée" testid="spec-exploded-view" thumbClass="aspect-[650/441]" />
      </div>
      <dl data-testid="spec-table" className="spec-list">
        {SPECS.map(([k, v]) => (
          <div key={k} className="spec-row">
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);
